"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPaginationFooterArrowsContainer = exports.StyledPaginationFooterCurrentPageContainer = exports.StyledPaginationFooterDropdown = exports.StyledPaginationFooterRowsPerPageContainer = exports.StyledPaginationFooterContainer = void 0;
const Theme_1 = require("../../Theme/Theme");
exports.StyledPaginationFooterContainer = Theme_1.styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height || 22}px;
  padding: 14px 16px;
  font-family: proxima-nova, sans-serif;
  font-size: 12px;
  color: ${(props) => props.theme.colors.gray[90]};
`;
exports.StyledPaginationFooterRowsPerPageContainer = Theme_1.styled.div `
  margin-right: 26px;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
`;
exports.StyledPaginationFooterDropdown = Theme_1.styled.select `
  border-radius: 0;
  border: none;
  text-align: center;
  font-size: 12px;
  background-color: ${(props) => props.theme.white};
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.gray[20]};
  }
`;
exports.StyledPaginationFooterCurrentPageContainer = Theme_1.styled.div `
  margin-right: 16px;
  width: 80px;
`;
exports.StyledPaginationFooterArrowsContainer = Theme_1.styled.div `
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
`;
//# sourceMappingURL=PaginationFooter.styles.js.map